// FILECONTENT_START src/common/components/Inputs/ButtonGroup/index.ts
import ButtonGroup from "./ButtonGroup";
export default ButtonGroup;
export type { ButtonGroupProps } from "./ButtonGroup";

// FILECONTENT_END src/common/components/Inputs/ButtonGroup/index.ts